<template>
    <div>
        <el-container >
        <div style="width:50%;float:left;">
            <!-- <el-aside>
                <el-input style=""  placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
            
                <el-tree class="filter-tree" :data="data" :props="defaultProps"  default-expand-all :filter-node-method="filterNode" @node-click="handleNodeClick" ref="tree"></el-tree>
            </el-aside> -->
            <h1>{{kwikiModel.KnowledgeTitle}}</h1>
            <div>
                <span style="margin-right:20px;">发布人：{{kwikiModel.SendUserName}}</span>
                <span>发布时间：{{kwikiModel.SendTime}}</span>
            </div>
            <div v-html="kcontent">
            </div>
        </div>
        <div style="width:50%;">
            <!-- <div :class="isShow==true?'show':'hidden'">
                <h1>{{wiki.KnowledgeTitle}}</h1>
                <div>
                    <el-tag effect="dark" class="darkTag" > 发布人：</el-tag>{{wiki.AddUserName}}
                    <el-tag effect="dark" class="darkTag" >发布时间: </el-tag>{{wiki.AddTime}}
                </div>
                 <div style="margin-top:10px;">
                    <el-tag effect="dark" class="darkTag">编辑人:</el-tag>{{wiki.EditUserNames}}
                    <el-tag effect="dark" class="darkTag">最近修改时间: </el-tag>{{wiki.LastEditTime}}
                </div>
                <div style="margin-top:20px;" v-html="content">
                    <!-- v-html 解析html标签，后面的赋值不需要添加{{}}
                </div>
            </div> -->
            <h1>{{wikiModel.KnowledgeTitle}}</h1>
            <div>
                <span style="margin-right:20px;">发布人：{{wikiModel.SendUserName}}</span>
                <span>发布时间：{{wikiModel.SendTime}}</span>
            </div>
            <div v-html="content">
            </div>
        </div>
        </el-container>
    </div>
    
</template>
<script>
import { GetSingleKnowledgeShadow,GetKnowledgeContentDescry,GetSingleKnowledge } from "../../until/ZeusApiSDK/Logic/WikiLogic";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";  
import { ImageAddDomain,getUrlKey  } from "../../until/ZeusApiSDK/Logic/ImageStr";
export default {
    data() {
        return {
            id:'',
            kid:'',
            content:'',//内容
            wikiModel:{},//单个百科影子信息
            kcontent:'',//对比内容
            kwikiModel:{},//对比百科影子
        };
    } ,
    methods: {
        //获取单个文章信息
        getSingleKnowledgeShadow:function(){
            //获取影子百科信息
            GetSingleKnowledgeShadow(this.id).then(res=>{
                this.wikiModel=res;
                GetKnowledgeContentDescry(this.wikiModel.KnowledgeContent).then(res=>{
                    //如返回的文本含有图片则为图片添加域名
                    var data= ImageAddDomain(res,'http://e.ruizhiqi.com');
                    this.content=data;
                });
            });
            //获取百科信息
            GetSingleKnowledge(this.kid).then(res=>{
                this.kwikiModel=res;
                GetKnowledgeContentDescry(this.kwikiModel.KnowledgeContent).then(res=>{
                    //如返回的文本含有图片则为图片添加域名
                    var data= ImageAddDomain(res,'http://e.ruizhiqi.com');
                    this.kcontent=data;
                });
            });
        },
    },
    //页面进入加载事件
    created:function(id){
        //获取地址栏id参数值
        this.id=getUrlKey('id'); 
        this.kid=getUrlKey('kid');
        //获取百科影子信息
        this.getSingleKnowledgeShadow();
    },
}
</script>